import * as ActionTypes from '../constants/ActionTypes';
import { push } from 'react-router-redux';
import { first } from 'lodash';
import { receiveEntity } from './entities';
import Post from '../records/post';
import Image from '../records/image';
import Schedule from '../records/schedule';
import Deal from '../records/deal';
import { uploadImagesToCloudinary } from '../actions/cloudinary';

import moment from 'moment';

import { Events } from 'ui-utilities';

export const newPost = type => {
  return (dispatch, getState) => {
    return dispatch({
      type: ActionTypes.NEW_POST,
      payload: type
    });
  }
};

export const toggleNav = bool => ({
  type: ActionTypes.TOGGLE_NAV,
  payload: bool
});

export const loadingPost = bool => ({
  type: ActionTypes.LOADING_POST,
  payload: bool
});

export const deletePost = post => {
  return (dispatch, getState) => {
    const vendor = getState()
      .entities
      .get('vendors')
      .get(post.vendor_id);

    return post.$delete()
      .then(res => post.image() && post.image().$delete())
      .then(res => Events
        .provide('kissmetrics', true)
        .log('Delete Post', {
          vendorId: vendor.id,
          'Merchant Location': vendor.places().first().toJS(),
          'Merchant Name': vendor.name,
          'Post Type': post.type,
          'Post Content': post.body
        }));
  }
}

export const saveDealPost = (id, inputs) => {
  return (dispatch, getState) => {
    const type = getState()
      .social
      .get('new')
      .get('type');

    if (type !== 'deal') return Promise.resolve(null);

    const getValue = label => inputs
      .find(i => i.label === label)
      .validations
      .val;

    const customRestrictions = getValue('customRestrictions').split(',');
    let restrictions;

    if (first(getValue('restrictions')) === 'None') {
      restrictions = customRestrictions;
    } else {
      restrictions = getValue('restrictions').concat(customRestrictions);
    }

    let customCodes = getValue('codes').trim().split(',');
    if (customCodes[0] === "" && customCodes.length === 1) customCodes = [];

    return new Schedule({
      owner_id: id,
      start_date: moment(getValue('start')).format('YYYY-MM-DD'),
      end_date: getValue('end') ? moment(getValue('end')).format('YYYY-MM-DD') : null
    })
    .$create()
    .then(res => dispatch(receiveEntity(res.data, 'schedules')))
    .then(res => new Deal({
      post_id: id,
      restrictions: restrictions,
      quantity: getValue('dealsSold'),
      expiration: getValue('promoLength'),
      max_per_user: getValue('purchases'),
      value_amount: (getValue('dealValue') / getState().social.get('deals').get('defaultDivisor')) * 100,
      paid_amount: getValue('dealValue') * 100,
      donation: getValue('donation'),
      recipient: getValue('recipient'),
      voucher_codes: customCodes
    })
    .$create())
    .then(res => dispatch(receiveEntity(res.data, 'deals')));
  }
}

export const saveSpecialPost = (id, inputs) => {
  return (dispatch, getState) => {
    const type = getState()
      .social
      .get('new')
      .get('type');

    if (type !== 'special') return Promise.resolve(null);

    const getValue = label => inputs
      .find(i => i.label === label)
      .validations
      .val;

    return new Schedule({
      owner_id: id,
      days: getValue('days')
        .filter(d => d.active)
        .map(d => d.text),
      hours: getValue('hours'),
      start_date: moment(getValue('start')).format('YYYY-MM-DD'),
      end_date: getValue('end') ? moment(getValue('end')).format('YYYY-MM-DD') : null
    }).$create()
    .then(res => dispatch(receiveEntity(res.data, 'schedules')));
  }
}

export const savePost = (inputs, image) => {
  return (dispatch, getState) => {
    dispatch(loadingPost(true));

    const vendorId = getState()
      .customer
      .get('account')
      .get('activeVendorId');

    const vendor = getState()
      .entities
      .get('vendors')
      .get(vendorId);

    const post = inputs.find(i => i.label === 'body').validations.val;

    return new Post({
      vendor_id: vendorId,
      body: post,
      type: getState().social.get('new').get('type')
    }).$create()
      .then(res => Promise.all([
        image && dispatch(uploadImagesToCloudinary(image))
        .then(url => new Image({
          owner_id: res.data.id,
          owner_type: 'posts',
          label: 'posts',
          url: url[0]
        }).$create()),
      dispatch(receiveEntity(res.data, 'posts'))
    ]))
    .then(res => Promise.all([
      dispatch(saveSpecialPost(res[1].data.id, inputs)),
      dispatch(saveDealPost(res[1].data.id, inputs))
    ]))
    .then(res => dispatch(loadingPost(false)))
    .then(res => Events
      .provide('kissmetrics', true)
      .log('Create Post', {
        vendorId: vendorId,
        'Merchant Location': vendor.places().first().toJS(),
        'Merchant Name': vendor.name,
        'Product Category': vendor.plan,
        'Post Type': post.type,
        'Post Content': post
      }))
    .then(res => dispatch(push('/dashboard')));
  }
}



// WEBPACK FOOTER //
// ./src/actions/social.js